<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">{{ title }}</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>
        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Fecha" min-width="120px" prop="date">
          <template #default="{ row }">
            <span>{{ row.date | date }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Usuario" min-width="120px" prop="user">
          <template #default="{ row }">
            <span>{{ row.user.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Asignado a" min-width="145px" prop="documentable">
          <template #default="{ row }">
            <router-link
              :to="{ name: getDocumentableRoute(row.documentableType), params: { id: row.documentableId } }"
              class="h5"
            >
              <span>{{ row.documentable.name }}</span>
            </router-link>
          </template>
        </el-table-column>

        <el-table-column label="Tipo Documento" min-width="180px" prop="type" sortable>
          <template #default="{ row }">
            <badge :type="row.type === 'stock' ? 'success' : 'primary'" class="m-1">
              {{ row.type }}
            </badge>
          </template>
        </el-table-column>

        <el-table-column label="Tipo Individuo" min-width="145px" prop="entity"> </el-table-column>

        <el-table-column label="Descripción" min-width="160px" prop="description" sortable>
          <template #default="{ row }">
            <span v-if="row.description">{{ row.description }}</span>
            <span v-else>{{ '&lt;vacío&gt;' }}</span>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="130px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'documents')"
              :to="{ name: 'DocumentShow', params: { id: row.id } }"
              class="btn base-button btn-outline-info btn-sm"
              title="ver"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <a :href="row.path" class="btn base-button btn-outline-dark btn-sm" target="_blank">
              <i class="fas fa-download"></i>
            </a>
            <button
              v-if="$can('destroy', 'documents')"
              title="Eliminar"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteDocument(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">
          Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} documentos
        </p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import paginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import swal from 'sweetalert2';

export default {
  name: 'DocumentsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [paginationOnServerMixin],
  props: {
    title: {
      type: String,
      default: 'Todos los Documentos',
    },

    entityId: {
      type: Number,
      default: null,
    },

    entity: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: '',
    },

    filterDistributor: {
      type: Number,
      default: null,
    },

    filterProducer: {
      type: Number,
      default: null,
    },

    filterDocumentableType: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      searchKeys: ['type', 'description', 'entity', 'documentable.name'],
      tableData: [],
      defaultSort: '-date',
      modelName: 'document',
    };
  },

  created() {
    this.fetchTableData();
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const parameters = {
        'filter[type]': this.type,
        'filter[producer]': this.filterProducer,
        'filter[distributor]': this.filterDistributor,
        'filter[documentable_type]': this.filterDocumentableType,
        'filter[entity]': this.entity,
        'filter[entity_id]': this.entityId,
        'filter[search]': this.mixSearchQuery,
        include: ['documentable', 'user'],
        sort: this.defaultSort,
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
      };

      this.$services
        .resource('documents')
        .get(parameters)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.documents));
    },

    deleteDocument(id) {
      swal({
        title: 'Se eliminará el documento',
        text: '¿Desea proceder?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value) {
          this.$services
            .resource('documents')
            .delete(id)
            .then(() => {
              return this.tableData.splice(
                this.tableData.findIndex((e) => e.id === id),
                1
              );
            })
            .then(() => swal('Listo!', 'El documento ha sido eliminado', 'success'));
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal('Cancelado', 'Su documento está a salvo :)', 'warning');
        }
      });
    },

    getDocumentableRoute(documentableType) {
      return documentableType == 'producers' ? 'ProducerShow' : 'DistributorShow';
    },
  },
};
</script>
